import { render, staticRenderFns } from "./ConfigVoip.vue?vue&type=template&id=ba1f3252&"
import script from "./ConfigVoip.vue?vue&type=script&lang=js&"
export * from "./ConfigVoip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports